/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, h} from 'preact';
import {PropTypes} from 'preact-compat';
import styles from '../../../css/fullScreenMessage.css';

class NoSignalScreen extends Component {
  render() {
    const mediaUri = this.props.mediaUri || '';

    if (!mediaUri) {
      return (
        <div className={styles.container}>
          <div className={styles.centerColumn}>
            <div className={styles['no-signal']} title={this.props.message || 'Offline'}/>
          </div>
        </div>
      );
    }

    const isVideo = mediaUri.includes('mp4');

    if (isVideo) {
      return (
        <div className={styles.container}>
          <div className={styles.centerColumn}>
            <video className={styles['no-signal']} src={mediaUri} autolay loop muted></video>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.container}>
        <div className={styles.centerColumn}>
          <img className={styles['no-signal']} src={mediaUri} alt={this.props.message || 'Offline'}></img>
        </div>
      </div>
    );
  }
}

NoSignalScreen.propTypes = {
  mediaUri: PropTypes.string,
  message: PropTypes.string
};

export default NoSignalScreen;